const BusinessEntityTypes = Object.freeze({
  LLC: 1,
  Corporation: 2,
});

export default BusinessEntityTypes;
